import { all, call, put, takeLatest, select } from 'redux-saga/effects'
import SettingsAction, {
  SettingsTypes,
  SettingsSelectors,
} from '../Redux/SettingsRedux'
import CalendlyEventActions from '../Redux/CalendlyEventRedux'

export function* onUpdate(api, action) {
  const settingsId = yield select(SettingsSelectors.settingsId)
  const resp = yield call(api.updateSettings, settingsId, action.params)
  if (resp.ok) {
    const settingsData = yield select(SettingsSelectors.settingsData)
    yield put(SettingsAction.settingsUpdateSuccess(resp.data))
    yield put(SettingsAction.setSettings({ ...settingsData, ...resp.data }))
    yield put(CalendlyEventActions.calendlyEventsListRequest())
    action.callback('success')
  } else {
    yield put(SettingsAction.settingsUpdateFailure('something went wrong'))
    action.callback('failure')
  }
}

export function* onStepUpdate(api, action) {
  const settingsId = yield select(SettingsSelectors.settingsId)
  const resp = yield call(api.updateSettings, settingsId, action.params)
  if (resp.ok) {
    const settingsData = yield select(SettingsSelectors.settingsData)
    yield put(SettingsAction.settingsStepUpdateSuccess(resp.data))
    yield put(SettingsAction.setSettings({ ...settingsData, ...resp.data }))
    if (action.callback) {  
      action.callback(resp.data)
    }
  } else {
    yield put(SettingsAction.settingsStepUpdateFailure('something went wrong'))
  }
}

export function* onShopSettingUpdate(api, action) {
  const settingsData = yield select(SettingsSelectors.settingsData)
  const resp = yield call(api.updateShop, action.params)
  if (resp.ok) {
    yield put(SettingsAction.shopSettingUpdateSuccess(resp.data))
  } else {
    yield put(SettingsAction.shopSettingUpdateFailure('something went wrong'))
  }
}

export function* onTextSettingUpdate(api, action) {
  const settingsData = yield select(SettingsSelectors.settingsData)
  const resp = yield call(api.updateTextSetting, {
    id: settingsData.id,
    ...action.params,
  })
  if (resp.ok) {
    yield put(SettingsAction.settingsUpdateSuccess(resp.data))
    yield put(
      SettingsAction.setSettings({ ...settingsData, text_setting: resp.data })
    )
    yield put(SettingsAction.textSettingUpdateSuccess(resp.data))
  } else {
    yield put(SettingsAction.textSettingUpdateFailure('something went wrong'))
  }
}

export function* onUpgrade(api, action) {
  const resp = yield call(api.upgradePlan, action.params)
  if (resp.ok) {
    action.callback(resp.data.confirmation_url, resp.data.shop)
  } else {
    yield put(SettingsAction.settingsPlanUpgradeFailure('something went wrong'))
  }
}

export function* addCalendlyToken(api, action) {
  const settingsData = yield select(SettingsSelectors.settingsData)
  const resp = yield call(api.addCalendlyToken, action.addCalendlyTokenParams)
  if (resp.ok) {
    yield put(SettingsAction.settingsAddCalendlyTokenSuccess(resp.data))
    yield put(
      SettingsAction.setSettings({
        ...settingsData,
        calendly_tokens: [...settingsData.calendly_tokens, resp.data],
      })
    )
    yield put(CalendlyEventActions.calendlyEventsListRequest())
    action.callback()
  } else {
    yield put(
      SettingsAction.settingsAddCalendlyTokenFailure('something went wrong')
    )
  }
}

export function* removeCalendlyToken(api, action) {
  const resp = yield call(
    api.removeCalendlyToken,
    action.removeCalendlyTokenParams
  )
  const settingsData = yield select(SettingsSelectors.settingsData)
  if (resp.ok) {
    yield put(SettingsAction.settingsRemoveCalendlyTokenSuccess(resp.data))
    yield put(
      SettingsAction.setSettings({
        ...settingsData,
        calendly_tokens: settingsData.calendly_tokens.filter(
          (t) => t.id !== action.removeCalendlyTokenParams.calendly_token_id
        ),
      })
    )
    action.callback()
  } else {
    yield put(
      SettingsAction.settingsRemoveCalendlyTokenFailure('something went wrong')
    )
  }
}

export function* onCancel(api, action) {
  const resp = yield call(api.cancelPlan)
  if (resp.ok) {
    //yield put(SettingsAction.settingsPlanCancelSuccess(resp.data))
    action.callback('success')
  } else {
    yield put(SettingsAction.settingsPlanCancelFailure('something went wrong'))
  }
}

export function* onConnectCalendar(api, action) {
  const settingsData = yield select(SettingsSelectors.settingsData)
  const resp = yield call(api.connectGoogleCalendar, { code: action.code })
  if (resp.ok) {
    if (resp.data.status) {
      yield put(
        SettingsAction.setSettings({
          ...settingsData,
          google_connection: resp.data.status,
        })
      )
      action.callback('success')
    } else {
      action.callback('failure')
    }
  }
}

export function* getAllCalendars(api, action) {
  const resp = yield call(api.getAllCalendars)
  if (resp.ok) {
    action.callback('success', resp.data)
  } else {
    action.callback('failure', null)
  }
}

export function* onRemoveCalendar(api, action) {
  const settingsData = yield select(SettingsSelectors.settingsData)
  const resp = yield call(api.removeGoogleCalendar)
  if (resp.ok) {
    yield put(
      SettingsAction.setSettings({
        ...settingsData,
        google_connection: {},
      })
    )
    action.callback('success')
  } else {
    action.callback('failure')
  }
}

export function* onRemoveZoom(api, action) {
  const settingsData = yield select(SettingsSelectors.settingsData)
  const resp = yield call(api.removeZoom)
  if (resp.ok) {
    yield put(
      SettingsAction.setSettings({
        ...settingsData,
        zoom_connection: {},
      })
    )
    action.callback('success')
  } else {
    action.callback('failure')
  }
}

export function* onTeamMemberUpdate(api, action) {
  const settingsData = yield select(SettingsSelectors.settingsData)
  const resp = yield call(api.updateTeamMemberSetting, action.params)
  if (resp.ok) {
    yield put(SettingsAction.settingsStepUpdateSuccess(resp.data))
    action.callback(resp.data)
  } else {
    yield put(SettingsAction.settingsStepUpdateFailure('something went wrong'))
    action.callback()
  }
}

export function* getStats(api, action) {
  console.log('getting stats')
  const resp = yield call(api.getStats, action.params)
  if (resp.ok) {
    action.callback(resp.data)
  }
}

export function* getUsageCharge(api) {
  const resp = yield call(api.getUsageCharge)
  if (resp.ok) {
    yield put(SettingsAction.usageListSuccess(resp.data))
  } else {
    yield put(SettingsAction.usageListFailure('something went wrong'))
  }
}

export function* onSync(api, action) {
  const resp = yield call(api.onSync)
  action.callback()
}

export function* onGenerateApiToken(api, action) {
  const resp = yield call(api.onGenerateApiToken)
  action.callback(resp.data)
}

export function* onGenerateZapierApiToken(api, action) {
  const resp = yield call(api.onGenerateZapierApiToken)
  action.callback(resp.data)
}

export function* checkAppBlock(api, action) {
  const resp = yield call(api.checkAppBlock)
  action.callback(resp.data)
}

export function* sendCustomerioEvents(api, action) {
  const resp = yield call(api.sendCustomerioEvents, action.params)
}

export function* checkCouponCode(api, action) {
  const resp = yield call(api.checkCouponCode, action.params)
  action.callback(resp.data)
}

export function* getDefaultLocale(api, action) {
  const resp = yield call(api.getDefaultLocale, action.params)
  if (resp.ok) {
    action.callback(resp)
  } else {
    action.callback(undefined)
  }
}

export function* orderTags(api, action) {
  const resp = yield call(api.getOrderTags)
  action.callback(resp)
}

export function* updateOrderTags(api, action) {
  const resp = yield call(api.updateOrderTags, action.params)
  action.callback(resp)
}

export function* connectAppleCalendarRequest(api, action) {
  const resp = yield call(api.connectAppleCalendar, action.params)
  action.callback(resp)
}

export function* disconnectAppleCalendarRequest(api, action) {
  const resp = yield call(api.disconnectAppleCalendarRequest)
  action.callback(resp)
}

export function* disconnectHubspot(api, action) {
  const resp = yield call(api.disconnectHubspot)
  action.callback(resp)
}

export function* verifyTextSettings(api, action) {
  const resp = yield call(api.verifyTextSettings, action)
  action.callback(resp.data)
}

export function* getTimezoneList(api, action) {
  const resp = yield call(api.getTimezone)
  if (resp.ok) {
    yield put(SettingsAction.timezoneListSuccess(resp.data))
  } else {
    yield put(SettingsAction.timezoneListFailure('something went wrong'))
  }
}

export function* deleteSenderSignature(api, action) {
  const resp = yield call(api.deleteSignature)
  action.callback(resp.data)
}

export function* getUsageData(api, action) {
  const resp = yield call(api.getUsageData, action.params)
  action.callback(resp.data)
}

export function* connectKlaviyoRequest(api, action) {
  const resp = yield call(api.connectKlaviyo, action.params)
  action.callback(resp.data)
}
export function* disconnectKlaviyoRequest(api, action) {
  const resp = yield call(api.disconnectKlaviyo, action.params)
  action.callback(resp)
}

export function* updateTrial(api, action) {
  const resp = yield call(api.updateTrial, action.params)
  action.callback(resp)
}

export function* me(api, action) {
  const resp = yield call(api.me)
  if (resp.ok) {
    action.callback(resp.data)
  } else {
    action.callback({})
  }
}


export default function* authSagas(api) {
  yield all([
    takeLatest(SettingsTypes.SETTINGS_UPDATE_REQUEST, onUpdate, api),
    takeLatest(SettingsTypes.SETTINGS_STEP_UPDATE_REQUEST, onStepUpdate, api),
    takeLatest(
      SettingsTypes.SHOP_SETTING_UPDATE_REQUEST,
      onShopSettingUpdate,
      api
    ),
    takeLatest(
      SettingsTypes.TEXT_SETTING_UPDATE_REQUEST,
      onTextSettingUpdate,
      api
    ),
    takeLatest(
      SettingsTypes.SETTINGS_TEAM_MEMBER_UPDATE_REQUEST,
      onTeamMemberUpdate,
      api
    ),
    takeLatest(SettingsTypes.SETTINGS_PLAN_UPGRADE_REQUEST, onUpgrade, api),
    takeLatest(SettingsTypes.SETTINGS_PLAN_CANCEL_REQUEST, onCancel, api),
    takeLatest(
      SettingsTypes.SETTINGS_ADD_CALENDLY_TOKEN_REQUEST,
      addCalendlyToken,
      api
    ),
    takeLatest(
      SettingsTypes.SETTINGS_REMOVE_CALENDLY_TOKEN_REQUEST,
      removeCalendlyToken,
      api
    ),
    takeLatest(SettingsTypes.GET_DEFAULT_LOCALE, getDefaultLocale, api),
    takeLatest(SettingsTypes.CONNECT_GOOGLE_CALENDAR, onConnectCalendar, api),
    takeLatest(SettingsTypes.GET_ALL_CALENDARS, getAllCalendars, api),
    takeLatest(SettingsTypes.DISCONNECT_GOOGLE_CALENDAR, onRemoveCalendar, api),
    takeLatest(SettingsTypes.DISCONNECT_ZOOM, onRemoveZoom, api),
    takeLatest(SettingsTypes.GET_STATS, getStats, api),
    takeLatest(SettingsTypes.USAGE_LIST_REQUEST, getUsageCharge, api),
    takeLatest(SettingsTypes.SYNC_REQUEST, onSync, api),
    takeLatest(SettingsTypes.GENERATE_API_TOKEN, onGenerateApiToken, api),
    takeLatest(
      SettingsTypes.GENERATE_ZAPIER_API_TOKEN,
      onGenerateZapierApiToken,
      api
    ),
    takeLatest(SettingsTypes.CHECK_APP_BLOCK, checkAppBlock, api),
    takeLatest(SettingsTypes.SEND_CUSTOMERIO_EVENTS, sendCustomerioEvents, api),
    takeLatest(SettingsTypes.CHECK_COUPON_CODE, checkCouponCode, api),
    takeLatest(SettingsTypes.ORDER_TAGS_REQUEST, orderTags, api),
    takeLatest(SettingsTypes.UPDATE_ORDER_TAGS, updateOrderTags, api),
    takeLatest(
      SettingsTypes.CONNECT_APPLE_CALENDAR_REQUEST,
      connectAppleCalendarRequest,
      api
    ),
    takeLatest(
      SettingsTypes.DISCONNECT_APPLE_CALENDAR_REQUEST,
      disconnectAppleCalendarRequest,
      api
    ),
    takeLatest(SettingsTypes.DISCONNECT_HUBSPOT, disconnectHubspot, api),
    takeLatest(SettingsTypes.VERIFY_TEXT_SETTINGS, verifyTextSettings, api),
    takeLatest(SettingsTypes.TIMEZONE_LIST_REQUEST, getTimezoneList, api),
    takeLatest(
      SettingsTypes.DELETE_SENDER_SIGNATURE,
      deleteSenderSignature,
      api
    ),
    takeLatest(SettingsTypes.GET_USAGE_DATA, getUsageData, api),
    takeLatest(
      SettingsTypes.CONNECT_KLAVIYO_REQUEST,
      connectKlaviyoRequest,
      api
    ),
    takeLatest(
      SettingsTypes.DISCONNECT_KLAVIYO_REQUEST,
      disconnectKlaviyoRequest,
      api
    ),
    takeLatest(SettingsTypes.UPDATE_TRIAL, updateTrial, api),
    takeLatest(SettingsTypes.ME, me, api),
  ])
}
